import { customCaseSensitiveSort } from 'components/common/Tables/Tables.utils';
import { columnsCommonConfig } from 'components/common/Tables/columnsCommonConfig';
import { DefaultColumnFilter } from 'components/common/Tables/components/ColumnFilter/ColumnFilter';

import { RowOptionsCell } from 'components/Settings/Components/RolesManagement/components/RowOptionCell';

export const defaultColumn = {
    Filter: DefaultColumnFilter,
};

export const initialState = {
    sortBy: [
        {
            id: 'label',
        },
    ],
};

export const columns = [
    {
        Header: 'Role name',
        accessor: 'label',
        width: 1285,
        sortType: customCaseSensitiveSort,
    },
    {
        Header: '',
        ...columnsCommonConfig.rowOptions,
        Cell: ({ row }) => {
            return <RowOptionsCell row={row} />;
        },
    },
];
